<template>
  <div class="index-menu-container">
    <!-- 查询条件 -->
    <el-card class="search-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('indexMenu.search.title') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input v-model="searchForm.name" :placeholder="$t('indexMenu.search.name')" clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="searchForm.isShow" :placeholder="$t('indexMenu.search.isShow')" style="width:100%">
            <el-option v-for="item in isShowOptions" :key="item.statusCd" :label="item.name" :value="item.statusCd" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="handleSearch">
            <i class="el-icon-search"></i>
            {{ $t('common.search') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <!-- 菜单列表 -->
    <el-card class="list-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('indexMenu.list.title') }}</span>
        <div style="float: right;">
          <el-button-group>
            <el-button type="primary" size="small" @click="openAddHouseKeepMenu">
              <i class="el-icon-plus"></i>
              {{ $t('indexMenu.button.addHouseKeep') }}
            </el-button>
            <el-button type="primary" size="small" @click="openAddServiceMenu">
              <i class="el-icon-plus"></i>
              {{ $t('indexMenu.button.addService') }}
            </el-button>
            <el-button type="primary" size="small" @click="openAddCategoryMenu">
              <i class="el-icon-plus"></i>
              {{ $t('indexMenu.button.addCategory') }}
            </el-button>
            <el-button type="primary" size="small" @click="openAddShopMenu">
              <i class="el-icon-plus"></i>
              {{ $t('indexMenu.button.addShop') }}
            </el-button>
            <el-button type="primary" size="small" @click="openAddMenu">
              <i class="el-icon-plus"></i>
              {{ $t('indexMenu.button.addMenu') }}
            </el-button>
          </el-button-group>
        </div>
      </div>

      <el-table :data="tableData" border style="width: 100%" v-loading="loading">
        <el-table-column prop="menuIcon" :label="$t('indexMenu.table.logo')" align="center" width="100">
          <template slot-scope="scope">
            <el-image style="width: 50px; height: 50px" :src="scope.row.menuIcon" fit="contain">
              <div slot="error" class="image-slot">
                <img src="/img/noPhoto.jpg" style="width: 50px; height: 50px">
              </div>
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('indexMenu.table.name')" align="center" />
        <el-table-column prop="seq" :label="$t('indexMenu.table.seq')" align="center" />
        <el-table-column prop="isShow" :label="$t('indexMenu.table.isShow')" align="center">
          <template slot-scope="scope">
            {{ scope.row.isShow === 'Y' ? $t('common.yes') : $t('common.no') }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('indexMenu.table.createTime')" align="center" />
        <el-table-column :label="$t('common.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.current" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
    </el-card>

    <!-- 子组件 -->
    <add-index-menu ref="addIndexMenu" @success="handleSuccess" />
    <add-house-keep-menu ref="addHouseKeepMenu" @success="handleSuccess" />
    <add-service-menu ref="addServiceMenu" @success="handleSuccess" />
    <add-shop-menu ref="addShopMenu" @success="handleSuccess" />
    <add-category-menu ref="addCategoryMenu" @success="handleSuccess" />
    <edit-index-menu ref="editIndexMenu" @success="handleSuccess" />
    <delete-index-menu ref="deleteIndexMenu" @success="handleSuccess" />
  </div>
</template>

<script>
import { listShopMenu } from '@/api/phone/indexMenuApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import AddIndexMenu from '@/components/phone/AddIndexMenu'
import AddHouseKeepMenu from '@/components/phone/AddHouseKeepMenu'
import AddServiceMenu from '@/components/phone/AddServiceMenu'
import AddShopMenu from '@/components/phone/AddShopMenu'
import AddCategoryMenu from '@/components/phone/AddCategoryMenu'
import EditIndexMenu from '@/components/phone/EditIndexMenu'
import DeleteIndexMenu from '@/components/phone/DeleteIndexMenu'

export default {
  name: 'IndexMenuList',
  components: {
    AddIndexMenu,
    AddHouseKeepMenu,
    AddServiceMenu,
    AddShopMenu,
    AddCategoryMenu,
    EditIndexMenu,
    DeleteIndexMenu
  },
  data() {
    return {
      loading: false,
      searchForm: {
        name: '',
        isShow: ''
      },
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      isShowOptions: [],
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.getList()
    this.getDictData()
  },
  methods: {
    async getList() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.current,
          row: this.pagination.size,
          name: this.searchForm.name,
          isShow: this.searchForm.isShow,
          shopId: this.shopId
        }
        const { data, total } = await listShopMenu(params)
        this.tableData = data
        this.pagination.total = total
      } catch (error) {
        this.$message.error(this.$t('indexMenu.fetchError'))
      } finally {
        this.loading = false
      }
    },
    async getDictData() {
      try {
        const data = await getDict('housekeeping_type', 'is_show')
        this.isShowOptions = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.current = val
      this.getList()
    },
    openAddMenu() {
      this.$refs.addIndexMenu.open()
    },
    openAddHouseKeepMenu() {
      this.$refs.addHouseKeepMenu.open()
    },
    openAddServiceMenu() {
      this.$refs.addServiceMenu.open()
    },
    openAddShopMenu() {
      this.$refs.addShopMenu.open()
    },
    openAddCategoryMenu() {
      this.$refs.addCategoryMenu.open()
    },
    handleEdit(row) {
      this.$refs.editIndexMenu.open(row)
    },
    handleDelete(row) {
      this.$refs.deleteIndexMenu.open(row)
    },
    handleSuccess() {
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.index-menu-container {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .list-card {
    margin-bottom: 20px;
  }

  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>